require('dotenv').config()

const backendURL = process.env.REACT_APP_API_URL;

export default backendURL;